import { AssetType } from "../../types/AssetType";
import { postCarbonSection } from "../../services/UploadService";
import { toast } from "react-toastify";
import { Auth } from "aws-amplify";
import ReactGA from "react-ga4";
import { CarbonSectionData } from "../../types/CarbonSection";
import { Inspection } from "../../types/Inspection";
import { saveInspectionResult } from "./Inspections";

export async function updateCarbonSectionData(data: CarbonSectionData, inspection: Inspection, dispatch: any) {
    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();

    return new Promise<void>((resolve) => {
        ReactGA.event({
            category: "Carbon Section Data",
            action: "adding",
            label: AssetType.CarbonOffsetting.toString(),
            value: 0
        });

        postCarbonSection(data, idToken)
            .then(() => {
                ReactGA.event({
                    category: "Carbon Section Data",
                    action: "added",
                    label: AssetType.CarbonOffsetting.toString(),
                    value: 0
                });
                toast.success(
                    "Successfully saved Carbon Offsetting information"
                );

                inspection.CarbonSectionData = data;
                dispatch(saveInspectionResult(inspection));
                resolve();
            })
            .catch((error) => {
                toast.error("Failed to save, please try again later.");
                console.error(error);
                ReactGA.event({
                    category: "Carbon Section Data",
                    action: "failed",
                    label: AssetType.CarbonOffsetting.toString(),
                    value: 0
                });
                resolve();
            });
    });
}

